import React from 'react';
import { Container } from 'react-bootstrap';

function About() {
  return (
    <Container className="about">
      <section>
        <div class="panel">
            <h1>About</h1>
            <p>My name is John Gerald S. Pizarro, I'm 21 years old and I live in Mamatid, Cabuyao, Laguna. I'm currently studying BSCS (Bachelor of Science in Computer Science).
              My hobbies are playing video games, watching movies/series and also biking.
            </p>
        </div>
    </section>
    </Container>
  );
}

export default About;
